/**
 * Output: 1/23/2024, 9:28:34 AM
 */
export const formatDate = (dateString) => {
  const options = { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

/**
 * Output: 1/23/2024
 */
export const formatDateMDY = (dateString) => {
  const options = { year: "numeric", month: "numeric", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

/**
 * Output: January 23, 2024
 */
export const formatDateLongFormat = (dateString) => {
  const options = { year: "numeric", month: "long", day: "numeric"};
  return new Date(dateString).toLocaleDateString(undefined, options);
};

/**
 * Output: 01022004 (<- January 2, 2004)
 */
export const formatDateMDYString = (dateString) => {
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  return new Date(dateString).toLocaleDateString(undefined, options).replaceAll('/','');
};
